// extracted by mini-css-extract-plugin
export default {"root":"BusinessAccounts_root__1KODN","filter":"BusinessAccounts_filter__HkEks"};